import React from "react"
import { Link } from "react-router-dom"

import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"

const CommunityViewEditorMetadata = ({
    creator,
    time,
    source,
    updatedBy,
    lastUpdated,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-community" />Created by
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={60}>
                <p>
                    {creator ? (
                        <Link to={`/users/${creator.id}`}>
                            {creator.full_name}
                        </Link>
                    ) : (
                        <em>Unknown</em>
                    )}
                    {time && `, ${time.local().format("llll")}`}
                </p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-source" />Source
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={20}>
                <p>{source || "CI"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-community" />Last updated by
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={60}>
                {!updatedBy && !lastUpdated ? (
                    "Not yet updated"
                ) : (
                    <p>
                        {updatedBy ? (
                            <Link to={`/users/${updatedBy.id}`}>
                                {updatedBy.full_name}
                            </Link>
                        ) : (
                            <em>Unknown</em>
                        )}
                        {lastUpdated &&
                            `, ${lastUpdated.local().format("llll")}`}
                    </p>
                )}
            </ContentLoaderLines>
        </div>
    </div>
)

export default CommunityViewEditorMetadata
